<template>
    <div class="noPermisson">
        <img src="../../assets/images/noper.png" alt="无权限" class="noPer"/>
        <div style="margin:24px 0;font-size:16px;">当前登录钉钉账号：{{userInfo.nick||'-'}}【{{userInfo.openid||''}}】</div>
        <div style="margin:24px 0;font-size:14px;color: #606266">您暂时没有权限操作，联系管理员为您添加权限，请确保电脑已经安装登录钉钉软件才能联系到管理员</div>
        <div style="width: 400px;margin: 0 auto">
            <el-button type="danger" style="display: block;width: 400px;" @click="toDingDing">
                联系管理员
            </el-button>
            <el-button type="info" style="display: block;width: 100%;margin-left: 0;margin-top: 10px;width: 400px;"
                       @click="goBack">返回
            </el-button>
        </div>
    </div>
</template>
<script>
    import config from "../../config";

    export default {
        name: 'noPermisson',
        data() {
            return {
                userInfo: {}
            }
        },
        mounted: function () {
            this.userInfo = localStorage.getItem('userDingDing') ? JSON.parse(localStorage.getItem('userDingDing')) : false;
        },
        methods: {
            goBack() {
                this.$router.push({path: '/login'});
                // this.$router.back()
            },
            toDingDing() {
                window.location.href = `dingtalk://dingtalkclient/action/sendmsg?dingtalk_id=${config.DD_ADMINISTRATOR_ID}`
            }
        }
    }
</script>
<style scoped>
    .noPermisson {
        margin-top: 10%;
    }

    .noPer {
        width: 173px;
        height: 134px;
    }
</style>